import { ICancellationReason } from '../types';

/** The backend's code for "Other" in both the shift and the interview lists. */
export const OTHER_CANCELLATION_REASON_CODE = 'other';

/** Matches on the code, not the name, so a renamed "Other" label keeps working. */
export const isOtherCancellationReason = (
  reason?: Pick<ICancellationReason, 'code'> | null,
): boolean => reason?.code === OTHER_CANCELLATION_REASON_CODE;
